import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  API_BLOCK: `${cleanedFilename(__filename)}-api-block`,
  API_KEY_DESCRIPTION: `${cleanedFilename(__filename)}-api-key-description`,
};
